frappe.ui.dynamic_links_cards = class DynamicLinksTable {
	constructor({ frm }) {
		this.frm = frm;
		this._wrapper = null;
		this.hideStandardTable();
	}

	trigger() {
		this.renderTable();
	}

	get wrapper() {
		return (this._wrapper ??= this.makeWrapper());
	}

	makeWrapper() {
		const customWrapper = this.frm?.fields_dict.links_html?.wrapper;
		if (customWrapper) return customWrapper;

		const standardTable = this.frm?.fields_dict.links?.wrapper;
		if (standardTable) {
			const div = document.createElement("div");
			standardTable.before(div);
			return div;
		}
	}

	hideStandardTable() {
		if (this.frm?.fields_dict.links) {
			this.frm.fields_dict.links.wrapper.style.display = "none";
		}
	}

	async renderTable() {
		if (!this.wrapper) return;
		const container = document.createElement("div");
		this.wrapper.innerHTML = "";
		this.wrapper.append(container);
		container.classList.add("frappe-control", "mb-4");

		const header = document.createElement("div");
		header.className = "d-flex justify-content-between align-items-center mb-3";
		header.innerHTML = `
			<h5 class="m-0">${__("Linked Documents")}</h5>
			<button class="btn btn-sm btn-primary">
				${frappe.utils.icon("add", "md")}
			</button>
		`;
		header.querySelector("button").addEventListener("click", () => {
			this.addNewLink();
		});
		container.append(header);

		const row = document.createElement("div");
		row.className = "row g-2";
		container.append(row);

		const links = this.getDynamicLinks();

		const cards = (links || []).map((link) => new DynamicLinkCard(link, this));
		for (const card of cards) {
			const cardElem = await card.render();
			row.append(cardElem);
		}
	}

	getDynamicLinks() {
		return this.frm.doc.links;
	}

	deleteLink(link) {
		const new_links = this.frm.doc.links.filter((row) => row.name != link.name);
		this.frm.clear_table("links");
		new_links.forEach((new_link) => {
			this.frm.add_child("links", new_link);
		});
		this.frm.refresh_field("links");
		this.trigger();
		this.frm.dirty();
	}

	addNewLink() {
		frappe.prompt(
			[
				{
					fieldname: "link_doctype",
					label: __("Doctype"),
					fieldtype: "Link",
					options: "DocType",
					reqd: 1,
					get_query: () => {
						return {
							query: "frappe.contacts.address_and_contact.filter_dynamic_link_doctypes",
							filters: {
								fieldtype: "HTML",
								fieldname:
									this.frm.doctype == "Contact"
										? "contact_html"
										: "address_html",
							},
						};
					},
				},
				{
					fieldname: "link_name",
					label: __("Name"),
					fieldtype: "Dynamic Link",
					reqd: 1,
					options: "link_doctype",
				},
			],
			(values) => {
				this.frm.add_child("links", values);
				this.frm.refresh_field("links");
				this.trigger();
			},
			__("Add a new Link"),
			__("Save")
		);
	}
};

class DynamicLinkCard {
	constructor(link, tableInstance) {
		this.link = link;
		this.tableInstance = tableInstance;
	}

	async getImageUrl() {
		try {
			await frappe.model.with_doctype(this.link.link_doctype);
			const meta = frappe.get_meta(this.link.link_doctype);
			if (!meta.image_field) return null;
			const doc = await frappe.db.get_value(
				this.link.link_doctype,
				this.link.link_name,
				meta.image_field
			);
			if (doc && doc.message) {
				return doc.message[meta.image_field];
			}
		} catch (e) {
			console.warn("Image could not be loaded for", this.link, e);
		}
	}

	async render() {
		const col = document.createElement("div");
		col.className = "col-12 col-md-6 col-lg-4 mb-3";

		const imageUrl = await this.getImageUrl();
		const linkUrl = frappe.utils.get_form_link(this.link.link_doctype, this.link.link_name);

		const image_section = imageUrl
			? `<img src="${imageUrl}" alt="${this.link.link_name}" class="rounded-circle mr-3" style="width:40px; height:40px; object-fit:cover;">`
			: `<span class="placeholder-text mr-3">${frappe.get_avatar(
					"avatar-medium",
					this.link.link_name
			  )}</span>`;

		const title = frappe.utils.escape_html(this.link.link_title || this.link.link_name || "");
		const subtitle =
			this.link.link_title && this.link.link_title != this.link.link_name
				? frappe.utils.escape_html(this.link.link_name || "")
				: "";

		col.innerHTML = `
			<div class="frappe-card d-flex position-relative h-100">
				<button type="button"
					class="btn btn-link position-absolute"
					style="top:5px; right:5px; font-size:1.2rem; line-height:1;"
					title="${__("Delete")}"
				>${frappe.utils.icon("delete", "md")}</button>
				<div class="card-body d-flex align-items-center p-3">
					${image_section}
					<div style="min-width:0;">
						<a href="${linkUrl}"
							class="font-weight-bold text-dark text-decoration-none d-block"
							style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
							${title}
						</a>
						<div class="text-muted small">${subtitle}</div>
						<small class="text-muted">${__(this.link.link_doctype)}</small>
					</div>
				</div>
			</div>
		`;

		col.querySelector("button").addEventListener("click", () => {
			this.tableInstance.deleteLink(this.link);
		});

		return col;
	}
}
